import React from 'react';
import FormSelectInput from 'common/FormSelectInput';

const SortDropdown = ({ value, onChange }) => {
    const sortOptions = [
        { id: 'date_newest', name: 'Date (Newest)' },
        { id: 'date_oldest', name: 'Date (Oldest)' },
        { id: 'amount_high', name: 'Amount (High to Low)' },
        { id: 'amount_low', name: 'Amount (Low to High)' },
        { id: 'customer_az', name: 'Customer (A-Z)' },
        { id: 'customer_za', name: 'Customer (Z-A)' },
    ];

    return (
        <div className="w-full">
            <FormSelectInput
                noLabel={true}
                name="sort"
                placeholder="Sort by..."
                required={false}
                options={sortOptions}
                optionKey="id"
                optionValue={['name']}
                value={value || ''}
                handleChange={onChange}
                inputSize={12}
                labelSize={0}
                style={{ marginBottom: '0px' }}
                className="custom-select-small"
            />
        </div>
    );
};

export default SortDropdown;

